import { SCOPE_CONTRACT_AWARDS, SCOPE_CONTRACT_OPPORTUNITIES, SCOPE_GRANT_OPPORTUNITIES } from '../../../../constants/search';

export const WATCH_SCOPES = [SCOPE_CONTRACT_OPPORTUNITIES, SCOPE_GRANT_OPPORTUNITIES, SCOPE_CONTRACT_AWARDS];
